export type LegalDoc = {
  id: 'privacidad' | 'terminos' | 'reembolso' | 'descargo'
  label: string
  title: string
  updated: string
  sections: Array<{ heading: string; body: string }>
}

export const legalDocs: LegalDoc[] = [
  {
    id: 'privacidad',
    label: 'Política de privacidad',
    title: 'Política de privacidad',
    updated: 'Última actualización: enero 2026',
    sections: [
      {
        heading: 'Qué información recopilamos',
        body: 'Recopilamos únicamente los datos que tú nos das al comprar: tu nombre y tu correo electrónico. Los datos de pago se procesan directamente en la pasarela de pago (Shopify) y nunca pasan por nuestros servidores.',
      },
      {
        heading: 'Para qué la usamos',
        body: 'Usamos tu correo para entregarte el eBook, enviarte el comprobante de compra y, si lo aceptas, mandarte consejos de entrenamiento. Puedes darte de baja con un clic en cualquier correo.',
      },
      {
        heading: 'Con quién la compartimos',
        body: 'No vendemos ni rentamos tu información a nadie. Solo la compartimos con los proveedores necesarios para operar (procesador de pagos y plataforma de correo), que están obligados a protegerla.',
      },
      {
        heading: 'Tus derechos',
        body: 'Puedes pedir en cualquier momento una copia de tus datos, corregirlos o solicitar que los borremos escribiendo a soporte@gymporprimeravez.com. Respondemos en un máximo de 72 horas.',
      },
    ],
  },
  {
    id: 'terminos',
    label: 'Términos y condiciones',
    title: 'Términos y condiciones',
    updated: 'Última actualización: enero 2026',
    sections: [
      {
        heading: 'Qué estás comprando',
        body: 'Estás comprando una licencia personal de uso del eBook digital «Gym por Primera Vez» en formato PDF por un pago único de $7 USD. No hay suscripciones ni cargos recurrentes.',
      },
      {
        heading: 'Uso permitido',
        body: 'Puedes leer, guardar e imprimir el eBook para tu uso personal. No está permitido revenderlo, copiarlo, distribuirlo ni compartirlo públicamente en su totalidad o en partes.',
      },
      {
        heading: 'Entrega',
        body: 'La entrega es 100% digital e inmediata al confirmarse el pago. Es tu responsabilidad escribir bien tu correo; si no recibes nada, revisa la carpeta de spam y escríbenos.',
      },
      {
        heading: 'Cambios',
        body: 'Podemos actualizar el contenido del eBook y estos términos. Si compraste, recibes las actualizaciones del material sin costo adicional.',
      },
    ],
  },
  {
    id: 'reembolso',
    label: 'Política de reembolso',
    title: 'Política de reembolso',
    updated: 'Última actualización: enero 2026',
    sections: [
      {
        heading: 'Garantía de 7 días',
        body: 'Si el eBook no te sirve, escríbenos dentro de los primeros 7 días después de la compra y te devolvemos los $7 USD completos. No necesitas explicar por qué.',
      },
      {
        heading: 'Cómo solicitarlo',
        body: 'Envía un correo a soporte@gymporprimeravez.com desde el mismo correo con el que compraste, con el asunto «Reembolso». Procesamos la devolución en un máximo de 5 días hábiles.',
      },
      {
        heading: 'A dónde llega el dinero',
        body: 'El reembolso se devuelve al mismo método de pago que usaste. El tiempo en que aparece en tu estado de cuenta depende de tu banco.',
      },
    ],
  },
  {
    id: 'descargo',
    label: 'Aviso médico y de resultados',
    title: 'Aviso médico y de resultados',
    updated: 'Última actualización: enero 2026',
    sections: [
      {
        heading: 'No es asesoría médica',
        body: 'El contenido de «Gym por Primera Vez» es informativo y educativo. No sustituye el diagnóstico, tratamiento ni la orientación de un médico, nutriólogo o fisioterapeuta.',
      },
      {
        heading: 'Consulta antes de entrenar',
        body: 'Si tienes alguna condición de salud, lesión previa, estás embarazada o tomas medicamentos, consulta a un profesional de la salud antes de empezar cualquier rutina de este eBook.',
      },
      {
        heading: 'Resultados',
        body: 'Los resultados varían según tu constancia, alimentación, descanso y genética. No garantizamos resultados físicos específicos en un tiempo determinado.',
      },
    ],
  },
]
